
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.408 7.617l-.637-.003c-.307-.003-.657-.005-1.051-.005-1.71 0-3.114-1.203-3.114-2.669V2.367c0-.202-.191-.367-.427-.367H6.2C3.879 2 2 3.62 2 5.607v8.62C2 16.311 3.968 18 6.396 18h7.412C16.123 18 18 16.39 18 14.402V7.977c0-.203-.19-.367-.427-.367l-.347.003c-.303.002-.609.004-.818.004zm-8.833 4.439h4.653c.386 0 .7-.267.7-.596 0-.329-.314-.596-.7-.596H7.575c-.386 0-.7.268-.7.596 0 .33.314.595.7.595z","fill":"#94A3B8"}}),_c('path',{attrs:{"d":"M13.844 2.454c-.28-.249-.773-.078-.773.267v2.11c0 .884.857 1.612 1.898 1.612.656.007 1.568.009 2.342.007.395 0 .597-.403.322-.647l-1.307-1.155c-.869-.768-1.83-1.619-2.482-2.194z","fill":"#94A3B8"}})])
          )
        }
      }
    